import { ChangeEvent, FC } from 'react';
import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
} from '@mui/material';

type FormCheckBoxFieldProps = {
  name: string;
  checked?: boolean;
  label: string;
  customFont?: string;
  customWeight?: string;
  customLetterSpacing?: string;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  fullWidth?: boolean;
  dataTestId?: string;
} & CheckboxProps &
  Pick<FormControlLabelProps, 'labelPlacement'>;

export const FormCheckBoxField: FC<FormCheckBoxFieldProps> = ({
  name,
  label,
  checked,
  customWeight,
  customLetterSpacing,
  handleChange,
  labelPlacement,
  fullWidth,
  customFont,
  dataTestId,
  ...otherProps
}) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          name={name}
          checked={checked}
          sx={{
            marginRight:
              labelPlacement === 'start' && fullWidth ? 4 : undefined,
            marginLeft: labelPlacement !== 'start' && fullWidth ? 4 : undefined,
            color: '#666666',
            '&.Mui-checked': {
              color: '#28C0A7', // Color when checked
              backgroundColor: 'transparent',
              '& .MuiSvgIcon-root': {
                // Styles for the checkmark icon
                color: '#28C0A7',
              },
            },
            '&.Mui-disabled': {
              opacity: 0.4,
            },
          }}
          size="small"
          onChange={handleChange}
          {...otherProps}
          {...(dataTestId && { 'data-testid': dataTestId })}
        />
      }
      labelPlacement={labelPlacement}
      sx={
        fullWidth
          ? {
              flexGrow: 1,
              width: '100%',
            }
          : undefined
      }
      slotProps={{
        typography: {
          display: fullWidth ? 'flex' : undefined,
          flexGrow: fullWidth ? 1 : undefined,
          color: '#000',
          fontSize: customFont ?? '16px',
          fontWeight: customWeight ?? '600',
          letterSpacing: customLetterSpacing ?? '0.5px',
        },
      }}
      label={label}
    />
  );
};
